/* ═══════════════════════════════════════════════════
   MONEST Product Video PiP Player — JavaScript
   File: assets/monest-product-video.js
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Autoplay all PiP videos ── */
  function initVideos() {
    document.querySelectorAll('.monest-pip-video').forEach(function (v) {
      v.muted = true;
      v.play().catch(function () {});
    });
  }

  /* ── Open lightbox ── */
  function openLightbox(productId, src) {
    var lightbox = document.getElementById('monest-lightbox-' + productId);
    var lbVideo  = document.getElementById('monest-lightbox-video-' + productId);
    if (!lightbox || !lbVideo) return;

    lbVideo.src = src;
    lbVideo.muted = false;
    lbVideo.currentTime = 0;
    lightbox.classList.add('is-open');
    document.body.classList.add('monest-open');

    lbVideo.play().catch(function () {
      lbVideo.muted = true;
      lbVideo.play();
    });
  }

  /* ── Close lightbox ── */
  function closeLightbox(productId) {
    var lightbox = document.getElementById('monest-lightbox-' + productId);
    var lbVideo  = document.getElementById('monest-lightbox-video-' + productId);
    if (!lightbox) return;

    lightbox.classList.remove('is-open');
    document.body.classList.remove('monest-open');

    if (lbVideo) {
      lbVideo.pause();
      lbVideo.src = '';
    }
  }

  /* ── Click handler (desktop) ── */
  function attachClickListeners() {
    document.addEventListener('click', function (e) {

      /* PiP wrapper clicked → open lightbox */
      var pip = e.target.closest('.monest-pip-wrapper');
      if (pip) {
        e.stopPropagation();
        e.preventDefault();
        openLightbox(
          pip.getAttribute('data-product-id'),
          pip.getAttribute('data-video-src')
        );
        return;
      }

      /* Close button */
      var closeBtn = e.target.closest('.monest-lightbox-close');
      if (closeBtn) {
        e.stopPropagation();
        closeLightbox(closeBtn.getAttribute('data-product-id'));
        return;
      }

      /* Backdrop click */
      var backdrop = e.target.closest('.monest-lightbox-backdrop');
      if (backdrop) {
        closeLightbox(backdrop.getAttribute('data-product-id'));
        return;
      }

    }, true); /* useCapture — fires before Ella's swiper */
  }

  /* ── Touch handler (mobile) ──
     touchend fires before Ella's swiper handler,
     stopPropagation prevents swipe detection stealing the tap */
  function attachTouchListeners() {
    document.addEventListener('touchend', function (e) {
      var pip = e.target.closest('.monest-pip-wrapper');
      if (pip) {
        e.stopPropagation();
        e.preventDefault();
        openLightbox(
          pip.getAttribute('data-product-id'),
          pip.getAttribute('data-video-src')
        );
        return;
      }

      var closeBtn = e.target.closest('.monest-lightbox-close');
      if (closeBtn) {
        e.stopPropagation();
        e.preventDefault();
        closeLightbox(closeBtn.getAttribute('data-product-id'));
        return;
      }

      var backdrop = e.target.closest('.monest-lightbox-backdrop');
      if (backdrop) {
        e.stopPropagation();
        closeLightbox(backdrop.getAttribute('data-product-id'));
        return;
      }

    }, true); /* useCapture */
  }

  /* ── Escape key ── */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      document.querySelectorAll('.monest-lightbox.is-open').forEach(function (lb) {
        closeLightbox(lb.id.replace('monest-lightbox-', ''));
      });
    }
  });

  /* ── Re-init after Ella section reload ── */
  document.addEventListener('shopify:section:load', initVideos);

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVideos();
      attachClickListeners();
      attachTouchListeners();
    });
  } else {
    initVideos();
    attachClickListeners();
    attachTouchListeners();
  }

})();